/**
 * Field-notebook design tokens.
 *
 * Shared by the cost estimator's form/sidebar and any educational sections
 * rendered alongside it so the whole page reads as one surface instead of
 * a calculator bolted onto generic shadcn cards.
 *
 * The Spectral/JetBrains Mono CSS variables are scoped to routes that load
 * the cost-tool font variables (see app/tools/lawn-cost-estimator/layout.tsx).
 * Tokens that fall back to system fonts here keep the file safe to import
 * from anywhere; only the font tokens are route-scoped in practice.
 */

export const NOTEBOOK = {
  bg: "#fbf9f4",
  bgDeep: "#f4efe5",
  ink: "#15201a",
  rule: "#e8e2d3",
  accent: "#15803d",
  muted: "rgba(21,32,26,0.62)",
  muted2: "rgba(21,32,26,0.45)",
  fontSerif: `var(--font-spectral), 'Iowan Old Style', Georgia, serif`,
  fontMono: `var(--font-jetbrains-mono), ui-monospace, 'SF Mono', Menlo, monospace`,
} as const
